<template>
  <div v-if="isVisible" class="announcement-bar hidden-sm-and-down">
    <!-- Animated background shimmer -->
    <div class="shimmer-overlay"></div>

    <div class="announcement-inner">
      <!-- Left decorative badge -->
      <!-- <div class="promo-badge">
        <span class="badge-icon">🎉</span>
        <span class="badge-text">SPECIAL OFFER</span>
      </div> -->

      <!-- Scrolling announcements -->
      <div class="marquee-wrapper">
        <div class="marquee-track">
          <span class="marquee-item" v-for="(msg, i) in messages" :key="'a-' + i">
            <span class="msg-text">{{ msg.text }}</span>
            <span v-if="msg.code" class="coupon-pill">{{ msg.code }}</span>
            <span class="dot-divider">✦</span>
          </span>
          <!-- Duplicate for seamless loop -->
          <span class="marquee-item" v-for="(msg, i) in messages" :key="'b-' + i">
            <span class="msg-text">{{ msg.text }}</span>
            <span v-if="msg.code" class="coupon-pill">{{ msg.code }}</span>
            <span class="dot-divider">✦</span>
          </span>
        </div>
      </div>

      <!-- Right side actions -->
      <!-- <div class="bar-actions">
        <router-link to="/products" class="shop-link">
          Shop Now
          <span class="arrow-icon">→</span>
        </router-link>
        <button class="close-btn" @click="isVisible = false" aria-label="Close announcement">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["storage"],
  data() {
    return {
      isVisible: true,
      messages: [
        { text: "Use coupon code for 10% off your order", code: "SAVE10" },
        // { text: "Free shipping on orders above ₹499", code: null },
        { text: "Fresh farm produce delivered to your door", code: null },
        { text: "New arrivals every week — explore the latest picks", code: null },
        // { text: "Refer a friend & earn ₹100 in store credit", code: null },
      ],
    };
  },
};
</script>

<style scoped>
.announcement-bar {
  position: relative;
  width: 100%;
  background: linear-gradient(90deg, #1a6e3f 0%, #2d9e60 40%, #3EA56E 60%, #1a6e3f 100%);
  background-size: 200% 100%;
  overflow: hidden;
  height: 38px;
  animation: gradientShift 8s ease infinite;
  z-index: 10;
}

@keyframes gradientShift {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Subtle shimmer overlay */
.shimmer-overlay {
  position: absolute;
  top: 0; left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    105deg,
    transparent 40%,
    rgba(255, 255, 255, 0.08) 50%,
    transparent 60%
  );
  animation: shimmerSlide 4s ease-in-out infinite;
  pointer-events: none;
  z-index: 1;
}

@keyframes shimmerSlide {
  0%   { left: -100%; }
  100% { left: 200%; }
}

.announcement-inner {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 16px;
  gap: 12px;
}

/* Left badge */
.promo-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  padding: 2px 10px;
  backdrop-filter: blur(4px);
}

.badge-icon {
  font-size: 12px;
  line-height: 1;
}

.badge-text {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #fff;
  font-family: 'ibmsemibold', sans-serif;
  white-space: nowrap;
}

/* Marquee */
.marquee-wrapper {
  flex: 1;
  overflow: hidden;
  mask-image: linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%);
}

.marquee-track {
  display: flex;
  align-items: center;
  white-space: nowrap;
  animation: marqueeScroll 35s linear infinite;
  will-change: transform;
}

.marquee-track:hover {
  animation-play-state: paused;
}

@keyframes marqueeScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.marquee-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
}

.msg-text {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.95);
  font-family: 'ibmregular', sans-serif;
  letter-spacing: 0.3px;
}

.coupon-pill {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  border: 1px dashed rgba(255, 255, 255, 0.7);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  font-family: 'ibmsemibold', sans-serif;
  letter-spacing: 1px;
  padding: 1px 8px;
  border-radius: 4px;
}

.dot-divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 8px;
  margin: 0 4px;
}

/* Right actions */
.bar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.shop-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 700;
  font-family: 'ibmsemibold', sans-serif;
  letter-spacing: 0.5px;
  color: #fff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  padding: 3px 12px;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.shop-link:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}

.arrow-icon {
  font-size: 13px;
  transition: transform 0.2s ease;
}

.shop-link:hover .arrow-icon {
  transform: translateX(3px);
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  transform: rotate(90deg);
}
</style>